import type { FundPricesResponse } from "@/FundPage/components/FundPrices/types";
import { useFundPageStore } from "@/FundPage/providers/Store";

export default function useShareClassPrices(
	data?: FundPricesResponse["prices"],
) {
	const shareClass = useFundPageStore((store) => store.activeShareClass);
	if (!shareClass || !data) return null;

	const prices = data.pricesData[shareClass.id];
	if (!prices || prices.length === 0) return null;

	const toPriceData = (datum: Record<string, string>) => {
		return data.headers.map(({ key }) => {
			return datum[key] ?? null;
		});
	};

	// values can be a '-' for a newly launched shareclass with only one price point
	return prices
		.filter((p) =>
			Object.values(p.values).every(
				(pv) => !!pv && (prices.length < 2 || pv !== "-"),
			),
		)
		.sort((a, b) => b.date.getTime() - a.date.getTime())
		.map((p) => toPriceData(p.values));
}
